import { localAsyncStorage } from "../features/diProviders";
import { LOCAL_STORAGE_KEYS_TO_CONVERT } from "./constants";
class LocalStorageService {
    guestUserId;
    userId;
    constructor() {
        this.guestUserId = null;
        this.userId = null;
    }
    generateUserKey = (key) => {
        const id = this.userId || this.guestUserId || "";
        return id ? `${key}_${id}` : key;
    };
    // method to set guest user id
    setGuestUserId(id) {
        this.guestUserId = id;
    }
    // method to set user id
    setUserId(id) {
        this.userId = id;
    }
    // method to set item in local storage
    setItem(key, value) {
        key = this.generateUserKey(key);
        return localAsyncStorage.setItem(key, value);
    }
    // method to get item from local storage
    getItem(key) {
        key = this.generateUserKey(key);
        const data = localAsyncStorage.getItem(key);
        return data;
    }
    // method to remove item from local storage
    removeItem(key) {
        key = this.generateUserKey(key);
        return localAsyncStorage.removeItem(key);
    }
    convertOldLocalStorageToNew = async () => {
        for (const key of LOCAL_STORAGE_KEYS_TO_CONVERT) {
            const value = await localAsyncStorage.getItem(key);
            if (value) {
                await this.setItem(key, value); // Set value in new format
                await localAsyncStorage.removeItem(key); // Remove old format
            }
        }
    };
}
const localStorageService = new LocalStorageService();
export default localStorageService;
